import React, { Component } from "react";
import Nprogress from "nprogress";
import ReactPlaceholder from "react-placeholder";
import "nprogress/nprogress.css";
import "react-placeholder/lib/reactPlaceholder.css";
import CircularProgress from "components/CircularProgress";
import { GOOGLE_MAP_PLACE_SECRET_KEY } from '../constants/Common';

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
      };
      Nprogress.start();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    componentDidMount() {
      (async () => {
        this.mounted = true;
        await this.loadGoogleMapsScript(); // Ensure Google Maps script is loaded
        const { default: Component } = await importComponent();
        Nprogress.done();
        if (this.mounted) {
          this.setState({
            component: <Component {...this.props} />,
          });
        }
      })();
    }

    loadGoogleMapsScript() {
      return new Promise((resolve) => {
        if (window.google) {
          resolve();
          return;
        }
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_PLACE_SECRET_KEY}&libraries=places`;
        script.async = true;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }
    
    render() {
      const Component = this.state.component || <CircularProgress />;
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
